import React from 'react';

export default function Loading({ className }) {
  return (
    <div className={`loading ${ className || '' }`}>
      Loading...
    </div>
  );
}